import {
	memo,
	useCallback,
	useEffect,
	useRef,
	useState,
	useTransition,
} from "react";

import styles from "styles/component/CourseMapOptionListTable.module.scss";
import styles1 from "styles/component/PopOver.module.scss";
import popoverStyles from "styles/component/CustomCoursePopOver.module.scss";
import {
	Box,
	Button,
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
	Stack,
} from "@mui/material";
import {
	FacilityElements,
	HoleElements,
	courseMapZoneTypeList,
} from "json/constants";
import {
	convertToLabelName,
	getModalProperties,
} from "services/utils";
import asset from "json/assets";
import * as _ from "underscore";
import { useDispatch, useSelector } from "react-redux";
import {
	clearCourseShapePropertiesDesc,
	clearCourseShapePropertiesSize,
	clearCourseShapePropertiesType,
	clearEditableCourseItem,
	setEditableCourseItem,
	setSelectedCourseZoneType,
	setVisibleFacilityElements,
	updateClubHouseCenter,
	updateCourseMapData,
	course_gps_vector_map_remove,
	course_map_gps_vector_details,
} from "redux/CourseMapSlice";
import { useSearchParams } from "react-router-dom";
import { useProfileUsername } from "hooks/ProfileDetails";
import { decryptSecretKey } from "services/utils";
import {} from "redux/CourseMapSlice";
import {
	useCourseGPSMappingData,
	useCourseMapData,
	useEditableCourseItem,
	useIsDrawingStatus,
	useVisibleFacilityElements,
} from "hooks/CourseMapDetails";
import useNotiStack from "hooks/useNotistack";
import ModalWrapper from "layout/ModalWrapper/ModalWrapper";
import NoificationModal from "pages/ModalPage/NoificationModal";
import eventEmitter from "services/event.emitter";
import events from "json/events";
import { useRefHook } from "hooks/useRefHook";
import {
	BULK_ALLOWED,
	normalizeFacilityForApi,
	supportsBulk,
} from "./FacilityFeatures.helper";

function FacilityFeatures({
	courseWiseData,
	clubHouseCenterData,
	element,
	setElement,
}) {
	let singleType = true;
	const secret_Key = decryptSecretKey();
	const username = useProfileUsername();
	const [searchParams] = useSearchParams();
	const id_courseFromQuery = searchParams.get("course");

	const dispatch = useDispatch();
	const ScrollableClient = useRef();
	const { toastError } = useNotiStack();
	const [isFormatPending, startTransition] = useTransition();

	const editableArea = useEditableCourseItem();
	const isDrawingStatus = useIsDrawingStatus();
	const modalProperties = getModalProperties();
	const courseMapData = useCourseMapData();
	const editableAreaRef = useRefHook(editableArea);

	const [openDelAllConfModal, setOpenDelAllConfModal] = useState(false);
	const [showableData, setShowableData] = useState([]);
	const visibleFacilityElementList = useVisibleFacilityElements();
	const [openConfModal, setOpenConfModal] = useState(false);
	const [selectedShape, setSelectedShape] = useState(null);
	const holeWiseData = useSelector((state) => state.CourseMap.holeWiseData);

	const hasPerimeters =
		Array.isArray(holeWiseData) &&
		holeWiseData.some((item) => item?.label === "Perimeter" && item?.hole > 0);

	const isAutoGenDisabled =
		isDrawingStatus || !_.isEmpty(editableArea) || !hasPerimeters;

	const handleAutoGenerateBackground = useCallback(() => {
		eventEmitter.emit(events.autoGenerateBackground);
	}, []);

	const handleChangeMarkerType = useCallback((event) => {
		eventEmitter.emit(events.resetDrawingMode);
		setElement(event.target.value);
	}, []);
	const handleClose = () => {
		setOpenConfModal(false);
	};

	const handleAllDelClose = () => {
		setOpenDelAllConfModal(false);
	};
	const fillData = () => {
		if (element === "Clubhousecenter") {
			//  if (!_.isEmpty(clubHouseCenterData)){
			setShowableData(
				!_.isEmpty(clubHouseCenterData) ? [clubHouseCenterData] : [],
			);
			let _redxObj = {
				//  hole: -1,
				type: courseMapZoneTypeList[`${element.toLowerCase()}`],
				element: element,
				data:
					clubHouseCenterData?.clubLat && clubHouseCenterData?.clubLon
						? [clubHouseCenterData]
						: [],
			};
			dispatch(setSelectedCourseZoneType(_redxObj));
			// }
			return;
		}
		if (element && !_.isEmpty(courseWiseData)) {
			startTransition(() => {
				// if (element === "Clubhousecenter") {
				//   //  if (!_.isEmpty(clubHouseCenterData)){
				//   setMaxModFieldCount(listMaxModField[`${element}`]);
				//   setShowableData(
				//     !_.isEmpty(clubHouseCenterData) ? [clubHouseCenterData] : []
				//   );
				//   let _redxObj = {
				//     //  hole: -1,
				//     type: courseMapZoneTypeList[`${element.toLowerCase()}`],
				//     element: element,
				//     data: !_.isEmpty(clubHouseCenterData) ? [clubHouseCenterData] : [],
				//   };
				//   dispatch(setSelectedCourseZoneType(_redxObj));
				//   // }
				//   return;
				// }

				let data = courseWiseData.filter((s) => s.label === element);
				setShowableData(data);
				let _redxObj = {
					hole: -1,
					type: courseMapZoneTypeList[`${element.toLowerCase()}`],
					element: element,
					// data:showableData?.length?showableData:(showableFCBData?.length? showableFCBData:[])
					data: data,
				};
				dispatch(setSelectedCourseZoneType(_redxObj));
			});
		} else {
			if (element === "Clubhousecenter") {
				let _redxObj = {
					//  hole: -1,
					type: courseMapZoneTypeList[`${element.toLowerCase()}`],
					element: element,
					data: [],
				};
				dispatch(setSelectedCourseZoneType(_redxObj));
				// }
				return;
			}

			let _redxObj = {
				hole: -1,
				type: courseMapZoneTypeList[`${element.toLowerCase()}`],
				element: element,
				// data:showableData?.length?showableData:(showableFCBData?.length? showableFCBData:[])
				data: [],
			};
			dispatch(setSelectedCourseZoneType(_redxObj));
		}
	};

	useEffect(() => {
		fillData();
		return () => {
			setShowableData([]);
		};
	}, [element, courseWiseData, clubHouseCenterData]);

	const hasElementData = (marker) => {
		if (
			marker?.value === "Clubhousecenter" &&
			clubHouseCenterData?.clubLat &&
			clubHouseCenterData?.clubLon
		) {
			return !_.isEmpty(clubHouseCenterData);
		}
		let data = courseWiseData.filter((s) => s.label === marker.value);
		return !_.isEmpty(data);
	};

	const toggleItemView = (data) => {
		const dataLabel =
			data?.label === "PracticeGreen"
				? "Practicegreen"
				: data?.label === "PracticeBunker"
					? "Practicebunker"
					: data?.label;

		if (checkIfActionable()) {
			let temp_visibleFacilityElementList = JSON.parse(
				JSON.stringify(visibleFacilityElementList),
			);

			let testSet = new Set(
				temp_visibleFacilityElementList[`${dataLabel}`].idList,
			);

			if (testSet.has(data?._id)) {
				testSet.delete(data._id);
			} else {
				testSet.add(data._id);
			}
			const newArray = [...testSet];
			temp_visibleFacilityElementList[`${dataLabel}`].idList = newArray;

			dispatch(setVisibleFacilityElements(temp_visibleFacilityElementList));
		}
	};

	const toggleAllItemView = () => {
		const getElement =
			element === "PracticeGreen"
				? "Practicegreen"
				: element === "PracticeBunker"
					? "Practicebunker"
					: element;

		if (checkIfActionable()) {
			let temp_visibleFacilityElementList = JSON.parse(
				JSON.stringify(visibleFacilityElementList),
			);
			temp_visibleFacilityElementList[`${getElement}`].isGroupVisible =
				!temp_visibleFacilityElementList[`${getElement}`].isGroupVisible;

			dispatch(setVisibleFacilityElements(temp_visibleFacilityElementList));
		}
	};

	const getActiveFacilityFeatureIcon = (data) => {
		const dataLabel =
			data?.label === "PracticeGreen"
				? "Practicegreen"
				: data?.label === "PracticeBunker"
					? "Practicebunker"
					: data?.label;

		if (visibleFacilityElementList[`${dataLabel}`]?.isGroupVisible) {
			let _t = new Set(visibleFacilityElementList[`${dataLabel}`].idList);
			return _t.has(data?._id);
		} else {
			return false;
		}
	};
	const isAllMemberVisible = () => {
		const getElement =
			element === "PracticeGreen"
				? "Practicegreen"
				: element === "PracticeBunker"
					? "Practicebunker"
					: element;

		return visibleFacilityElementList[`${getElement}`]?.isGroupVisible;
	};
	const checkIfActionable = () => {
		if (isDrawingStatus || !_.isEmpty(editableArea)) {
			return false;
		} else return true;
	};

	const getDeleteConfirmation = (data) => {
		setOpenConfModal(true);
	};

	const getDeleteAllConfirmation = () => {
		if (!BULK_ALLOWED.has(element)) {
			toastError(`${convertToLabelName(element)} supports only a single item.`);
			return;
		}
		if (checkIfActionable()) {
			setOpenDelAllConfModal(true);
		} else {
			toastError("can not delete elements while draw/edit is active");
		}
	};

	const deleteSingleElement = (data) => {
		if (checkIfActionable()) {
			setSelectedShape(data);
			getDeleteConfirmation();
		} else {
			toastError("can not delete elements while draw/edit is active");
		}
	};
	const clearAllElements = async () => {
		if (!BULK_ALLOWED.has(element)) return; // silently ignore for single-only

		const apiElement = normalizeFacilityForApi(element);
		try {
			// backend remove (course-wide for this element)
			await dispatch(
				course_gps_vector_map_remove({
					body: { id_courseInt: Number(id_courseFromQuery), name: apiElement },
					user: { secretKey: secret_Key, userName: username },
				}),
			);

			// refresh from backend to keep Redux in sync
			await dispatch(
				course_map_gps_vector_details({
					body: { id_course: id_courseFromQuery },
					user: { secretKey: secret_Key, userName: username },
				}),
			);

			// local defensive cleanup (in case)
			const temp = structuredClone(courseMapData);
			if (temp?.[element]) {
				delete temp[element];
				dispatch(updateCourseMapData(temp));
			}
		} catch (e) {
			toastError(
				`Failed to delete all ${convertToLabelName(element)}. Please try again.`,
			);
		}
	};

	const courseGPSMapping = useCourseGPSMappingData();
	const confirmationAction = () => {
		// eventEmitter.emit('ss',{id:selectedShape.id,selectedHole:parseInt(selectedHole),element:element})
		// handleClose();
		if (selectedShape) {
			if (element === "Clubhousecenter") {
				dispatch(updateClubHouseCenter({ clubLat: 0, clubLon: 0 }));
				eventEmitter.emit(
					events.deleteCourseMapElement.courseMapSimpleDataDelete,
					{ data: courseGPSMapping?.GPSList, custLat: "0", custLon: "0" },
				);
			} else {
				let temp_courseMapData = structuredClone(courseMapData);

				eventEmitter.emit(events.deleteCourseMapElement.courseMapVectorDelete, {
					idList: [selectedShape._id],
					type: "facility",
				});

				if (temp_courseMapData?.[element]?.Shapes?.Shape) {
					temp_courseMapData[element].ShapeCount -= 1;
					let pos = temp_courseMapData[element].Shapes.Shape.findIndex(
						(s) => s.id === selectedShape._id,
					);
					if (pos >= 0) {
						temp_courseMapData[element].Shapes.Shape.splice(pos, 1);
					}
					dispatch(updateCourseMapData(temp_courseMapData));
				}
			}

			handleClose();
		}
	};
	const confirmationDelAllAction = () => {
		clearAllElements();
		handleAllDelClose();
	};
	const hasSingleData = () => !BULK_ALLOWED.has(element);

	const getElementFlyToZone = (data) => {
		if (data?.label === "Clubhousecenter") {
			eventEmitter.emit(events.zoomMapToCoordinate, {
				coordinate: [data?.clubLat, data?.clubLon],
			});
		} else {
			eventEmitter.emit(events.zoomMapToCoordinate, {
				coordinate: [data?.list[0]?.[0][0], data?.list[0]?.[0][1]],
			});
		}
	};
	const isShapeHoleItem = (shape) => {
		return shape && shape.zone
			? HoleElements.some((s) => s.toLowerCase() === shape?.zone.toLowerCase())
			: false;
	};
	const clearEditableModeVariables = () => {
		dispatch(clearEditableCourseItem());
		dispatch(clearCourseShapePropertiesType());
		dispatch(clearCourseShapePropertiesSize());
		dispatch(clearCourseShapePropertiesDesc());
	};
	const toggleEditMode = (shape) => {
		if (isDrawingStatus) return;

		if (shape?.hole === -1) {
			if (_.isEmpty(editableAreaRef.current)) {
				dispatch(setEditableCourseItem(shape));
			}
			return;
		}

		if (_.isEmpty(editableAreaRef.current)) {
			let isHoleItem = isShapeHoleItem(shape);

			if (isHoleItem) {
				switch (shape?.zone) {
					case "Greencenter":
						if (editableArea?.greenID === shape?.greenID) {
							clearEditableModeVariables();
						} else {
							dispatch(setEditableCourseItem(shape));
						}
						break;
					default:
						if (editableArea?._id === shape?._id) {
							// dispatch(clearEditableCourseItem());
							clearEditableModeVariables();
						} else {
							dispatch(setEditableCourseItem(shape));
						}
						break;
				}
			} else {
				dispatch(setEditableCourseItem(shape));
			}
		}
	};

	return (
		<>
			<div
				className={`${
					!singleType
						? `${styles.table_select}`
						: `${styles.table_select}${styles.table_blank}`
				}`}
			>
				<Box className={popoverStyles.poover_content}>
					<Box
						className={`${popoverStyles.popover_body_new} ${popoverStyles.popover_body_courseMapList}`}
					>
						<FormControl>
							<RadioGroup
								className={styles.marker_option}
								aria-labelledby="demo-radio-buttons-group-label"
								// defaultValue="FLAG"
								name="radio-buttons-group"
								// value={"Hole 1"}
								value={element}
								onChange={(e) => {
									// if (checkIfActionable()) {
									handleChangeMarkerType(e);
									// }
								}}
							>
								{FacilityElements?.map((marker, index) => (
									<>
										<FormControlLabel
											className={`facility_element_layout ${
												hasElementData(marker)
													? `${popoverStyles.green_border}`
													: ""
											}`}
											value={marker.value}
											control={<Radio checked={marker.value === element} />}
											// control={<Radio checked={marker.value === "teeboxes"} />}
											label={marker.label}
											key={index}
										/>
									</>
								))}
							</RadioGroup>
						</FormControl>
					</Box>
				</Box>

				<div
					className={styles.table_btm}
					ref={ScrollableClient}
					id="listContainer"
				>
					{element === "Background" && (
						<Box sx={{ p: 1, textAlign: "center" }}>
							<Button
								fullWidth
								variant="contained"
								size="small"
								disabled={isAutoGenDisabled}
								onClick={handleAutoGenerateBackground}
								sx={{
									textTransform: "none",
									fontSize: "14px",
									backgroundColor: "#133E84",
									fontWeight: "400",
									"&:hover": { backgroundColor: "#0f3068" },
									"&.Mui-disabled": { backgroundColor: "#ccc" },
								}}
							>
								AUTO-GENERATE BACKGROUND
							</Button>
						</Box>
					)}
					{_.isEmpty(showableData) ? (
						<div className={styles1.list_icon_para}>
							<p className={styles.no_marker_text}>
								{!isFormatPending ? (
									<>{`No ${element} Mapped`}</>
								) : (
									<>Loading {element}</>
								)}
							</p>
						</div>
					) : (
						<table className={""} id={"list_table"}>
							<thead>
								{supportsBulk(element) && (
									<tr>
										<th>{`All ${convertToLabelName(element)}`}</th>
										<th>
											<Box className={styles.color_mod_box}>
												<Button
													className={`${
														isAllMemberVisible(element)
															? styles.green
															: styles.grey
													}`}
													// disabled={editableArea}
													onClick={toggleAllItemView}
												>
													<img src={asset.eye} alt="" className="eye_size" />
												</Button>
											</Box>
										</th>
										<th>
											<Box className={styles.color_mod_box}>
												<Button
													// disabled={editableArea}
													className={`${styles.green}`}
													onClick={getDeleteAllConfirmation}
												>
													<img src={asset?.close} alt="" />
												</Button>
											</Box>
										</th>
									</tr>
								)}
							</thead>
							<tbody>
								{showableData[0]?.label === "Clubhousecenter" ? (
									<>
										{showableData[0]?.clubLat !== undefined &&
										showableData[0]?.clubLon !== undefined ? (
											<>
												{showableData?.map((data, index) => {
													return (
														<tr
															key={index}
															id={data?.label}
															className={
																hasSingleData()
																	? `${styles.single_list_item}`
																	: ""
															}
														>
															<td
																onClick={() => {
																	getElementFlyToZone(data);
																	toggleEditMode(data);
																}}
															>
																<Stack
																	direction={"row"}
																	alignItems={"center"}
																	flexWrap={"wrap"}
																	justifyContent={"space-between"}
																>
																	{/* {data?.label[0]} */}
																	{data?.label}

																	{/* {index + 1} */}
																</Stack>
															</td>

															<td>
																<Box className={styles.color_mod_box}>
																	<Button
																		id={index}
																		className={
																			getActiveFacilityFeatureIcon(data)
																				? // && !editableArea
																					`${styles.green}`
																				: `${styles.grey}`
																		}
																		// disabled={editableArea}
																		// onClick={() => {}}
																		onClick={() => {
																			toggleItemView(data);
																		}}
																	>
																		<img
																			src={asset?.eye}
																			alt=""
																			className="eye_size"
																		/>
																	</Button>
																</Box>
															</td>
															<td>
																<Box className={styles.color_mod_box}>
																	<Button
																		//  disabled={editableArea}
																		onClick={() => {
																			deleteSingleElement(data);
																		}}
																	>
																		<img src={asset?.close} alt="" />
																	</Button>
																</Box>
															</td>
														</tr>
													);
												})}
											</>
										) : (
											<div className={styles1.list_icon_para}>
												<p className={styles.no_marker_text}>
													{!isFormatPending ? (
														<>{`No ${element} Mapped`}</>
													) : (
														<>Loading {element}</>
													)}
												</p>
											</div>
										)}
									</>
								) : (
									<>
										{showableData?.map((data, index) => {
											return (
												<tr
													key={index}
													id={data?.label}
													className={
														hasSingleData() ? `${styles.single_list_item}` : ""
													}
												>
													<td
														onClick={() => {
															getElementFlyToZone(data);
															toggleEditMode(data);
														}}
													>
														<Stack
															direction={"row"}
															alignItems={"center"}
															flexWrap={"wrap"}
															justifyContent={"space-between"}
														>
															{/* {data?.label[0]} */}
															{/* {data?.label} */}
															{BULK_ALLOWED.has(data?.label)
																? `${convertToLabelName(data?.label)} ${index + 1}`
																: convertToLabelName(data?.label)}
															{/* {index + 1} */}
														</Stack>
													</td>

													<td>
														<Box className={styles.color_mod_box}>
															<Button
																id={index}
																className={
																	getActiveFacilityFeatureIcon(data)
																		? // && !editableArea
																			`${styles.green}`
																		: `${styles.grey}`
																}
																// disabled={editableArea}
																// onClick={() => {}}
																onClick={() => {
																	toggleItemView(data);
																}}
															>
																<img
																	src={asset?.eye}
																	alt=""
																	className="eye_size"
																/>
															</Button>
														</Box>
													</td>
													<td>
														<Box className={styles.color_mod_box}>
															<Button
																//  disabled={editableArea}
																onClick={() => {
																	deleteSingleElement(data);
																}}
															>
																<img src={asset?.close} alt="" />
															</Button>
														</Box>
													</td>
												</tr>
											);
										})}
									</>
								)}
							</tbody>
						</table>
					)}
				</div>
			</div>
			<ModalWrapper
				open={openConfModal}
				onClose={handleClose}
				handleClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<NoificationModal
					label="Warning"
					backgroundColor={modalProperties.info.backgroundColor}
					image={modalProperties.warning.icon}
					title={`<span style='font-size:14px'>Are you sure you want to delete 
                 <br/>${element}?
                 </span>`}
					// content="Any unsaved data will be discarded."
					rejCallBack={handleClose}
					affrCallBack={confirmationAction}
					affrBtnTxt={"Continue"}
					rejBtnTxt={"Cancel"}
				/>
			</ModalWrapper>

			<ModalWrapper
				open={openDelAllConfModal}
				onClose={handleAllDelClose}
				handleClose={handleAllDelClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<NoificationModal
					label="Warning"
					backgroundColor={modalProperties.info.backgroundColor}
					image={modalProperties.error.icon}
					title={`<span style='font-size:14px'>Are you sure you want to delete 
            <br/>all ${element}?</span>`}
					// title={`<span style='font-size:14px'>Are you sure you want to delete
					//      <br/>all data from ${convertToLabelName((selectedHole))}?</span>`}
					// content="Any unsaved data will be discarded."
					rejCallBack={handleAllDelClose}
					affrCallBack={confirmationDelAllAction}
					affrBtnTxt={"Continue"}
					rejBtnTxt={"Cancel"}
				/>
			</ModalWrapper>
		</>
	);
}

export default memo(FacilityFeatures);
